import React, { useEffect, useState } from 'react';

interface TooltipPosition {
  x: number;
  y: number;
}

const ItemNameTooltip = ({ name }: { name: string }) => {
  const [position, setPosition] = useState<TooltipPosition | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    document.addEventListener("mousemove", (e) => {
      setPosition({
        x: e.clientX,
        y: e.clientY - 16
      })
    }, { signal: controller.signal })

    return () => {
      controller.abort();
    }
  }, [])

  return (
    <span className="map-item-name-tooltip" style={{
      top: position?.y || 0,
      left: position?.x || 0,
    }}>
      {name}
    </span>
  )
}

export default ItemNameTooltip;
